import type { BaseHttpRequest } from '@/api/generated-client/core/BaseHttpRequest';
import { ListGameCommentComplaintsParameters } from '@/api/parameters';
import {
  CommentComplaintDto,
  PaginatedCommentComplaintsResponseDto,
  UpdateCommentComplaintRequestDto,
} from '@/api/models';
import { UserProfile } from '@/api/models/user-profile.dto';
import { BaseApi } from '@/api/base-api';

export class ComplaintsApi extends BaseApi {
  constructor(public readonly httpRequest: BaseHttpRequest) {
    super();
  }

  private controller = '/catalog/comments';

  public async listGameCommentComplaints(
    query: ListGameCommentComplaintsParameters,
  ): Promise<PaginatedCommentComplaintsResponseDto> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[GET] /api/v1/game-comments/complaints?${this.queryToQueryString(query)}`,
      {}
    );
  }

  public async getCommentComplaint(id: number): Promise<CommentComplaintDto & UserProfile> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[GET] /api/v1/game-comments/complaints/${id}`,
      {}
    );
  }

  public async updateCommentComplaint(
    id: number,
    data: UpdateCommentComplaintRequestDto
  ): Promise<CommentComplaintDto & UserProfile> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[PATCH] /api/v1/game-comments/complaints/${id}`,
      data,
    );
  }
}
